(function () {
    if (!require('./platform').has_canvas) {
        var doc = require('./dom').doc;
        var rule = ".needs_canvas { display:none !important; }\n";

        if ('styleSheet' in doc.id('needs_css'))
            doc.id('needs_css').styleSheet.cssText += rule;
        else
            doc.id('needs_css').textContent        += rule;
    }
})();
(function () {
    if (!require('./platform').has_canvas) {
        var doc = require('./dom').doc;
        var rule = ".needs_canvas { display:none !important; }\n";

        if ('styleSheet' in doc.id('needs_css'))
            doc.id('needs_css').styleSheet.cssText += rule;
        else
            doc.id('needs_css').textContent        += rule;
    }
})();
